import React from 'react';
import { CheckIcon, KeyIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { benefits } from '../data/content';
type SolutionSectionProps = {
  checkoutUrl: string;
};
export function SolutionSection({
  checkoutUrl
}: SolutionSectionProps) {
  return <section className="border-b border-white/5 bg-ink-950 py-16 sm:py-20" aria-labelledby="solucion-title" data-id="element-89" data-mp="3j961pfq7q56t">
      <div className="mx-auto max-w-6xl px-5" data-id="element-90" data-mp="139td40hxlt0">
        <div className="flex items-center gap-3" data-id="element-91" data-mp="3t8dea0p4hvsv">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-flame/15 text-flame" data-id="element-92" data-mp="3t7lsfhlbvcfs">
            <KeyIcon className="h-5 w-5" aria-hidden="true" data-id="element-93" data-mp="atw5upcx1w7h" />
          </span>
          <span className="text-sm font-bold uppercase tracking-[0.16em] text-flame" data-id="element-94" data-mp="5wcfws6uvuzp">La llave maestra</span>
        </div>

        <h2 id="solucion-title" className="mt-5 max-w-3xl font-display text-3xl font-black uppercase leading-tight tracking-tight text-white sm:text-5xl" data-id="element-95" data-mp="kt3j7cjnhqul">
          «Gym por Primera Vez» te abre la puerta que hoy te da miedo
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-white/60" data-id="element-96" data-mp="3b8xcdsqzz0k2">
          Una guía de $7 que reemplaza al entrenador de $300 el mes: te dice exactamente qué hacer del día 1 al día 30.
        </p>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1.1fr_0.9fr]" data-id="element-97" data-mp="3kandjqaoldv1">
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-98" data-mp="3p9hs2g1m8g9c">
            {benefits.map(benefit => <li key={benefit.title} className="flex flex-col rounded-xl border border-white/10 bg-ink-850 p-5" data-id="element-99" data-mp="3u8l10bkpv6ml">
                <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-flame text-white" data-id="element-100" data-mp="2uf7u109m357">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="6xlayzs2ze7g" />
                </span>
                <h3 className="mt-4 font-display text-lg font-extrabold leading-snug text-white" data-id="element-102" data-mp="bsqvbu5u4ktf">{benefit.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/55" data-id="element-103" data-mp="2cwjnwoaw0ybe">{benefit.body}</p>
              </li>)}
          </ul>

          <div className="flex flex-col rounded-2xl border border-flame/30 bg-ink-900 p-6 sm:p-8" data-id="element-104" data-mp="27z1c8q5hk4zp">
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-white/40" data-id="element-105" data-mp="2mnebbvzve3yf">Precio de lanzamiento</p>
            <div className="mt-3 flex items-end gap-3" data-id="element-106" data-mp="2hubg7jfg2mg4">
              <span className="font-display text-6xl font-black leading-none text-white" data-id="element-107" data-mp="2vmrlkqvtiwk7">$7</span>
              <span className="pb-2 text-sm text-white/50" data-id="element-108" data-mp="2rm8rsrad7gfd">
                USD · pago único
                <br data-id="element-109" data-mp="35l8f9vm55p9y" />
                <span className="line-through decoration-flame/70" data-id="element-110" data-mp="35lqijc7813rd">antes $27</span>
              </span>
            </div>
            <ul className="mt-6 space-y-2.5 text-sm text-white/70" data-id="element-111" data-mp="30mx67n3o7iss">
              {['Acceso inmediato al PDF completo', 'Rutina imprimible de 30 días', 'Garantía de 7 días o te devolvemos el dinero'].map(item => <li key={item} className="flex gap-2.5" data-id="element-112" data-mp="16apdmgetne06">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame" strokeWidth={3} aria-hidden="true" data-id="element-113" data-mp="3hw84ubg9n5yc" />
                    <span data-id="element-114" data-mp="3mu174teg7ftc">{item}</span>
                  </li>)}
            </ul>
            <div className="mt-auto pt-8" data-id="element-115" data-mp="383tzz9tw5j7y">
              <CtaButton href={checkoutUrl} className="w-full" data-id="element-116" data-mp="3d47yo19lrgtb">
                Sí, dame mi guía por $7
              </CtaButton>
              <TrustRow className="mt-4" align="center" data-id="element-117" data-mp="2z3nfh3zrziza" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}